import { Logs } from "./Logs";

export class InventoryHeader {

    constructor(store, formObject) {
        this.store = store;
        this.formObject = formObject;
        this.element = null;
        this.moveButton = null;
        this.logsContainer = document.createElement("div");
        this.logsContainer.id = 'LOGSCONTAINER'
        this.logs = new Logs(this.store, this.logsContainer);
        this.onShowLogs = null;
        this.onHideLogs = null;
        this.logsVisible = false;
        this.logbutton = document.createElement("div");
    }

    render() {
        const headerWrapper = document.createElement("div");
        headerWrapper.className = "wrapper width-100 row border-bottom margin-bottom-1 padding-left-2 padding-right-2 padding-bottom-1";
        headerWrapper.id = 'HEADWRAPPER'
        // BAL OLDAL
        const left = document.createElement("div");
        left.className = this.store.config.isSmall ? "wrapper column width-50" : "wrapper width-50";
        left.id = 'HEADERTITLE'
        const category = document.createElement("div");
        category.className = this.store.config.isSmall ? "font-17 weight-600 margin-right-5" : "font-35 weight-600 margin-right-5";
        category.textContent = this.formObject.category || "-";
        const brand = document.createElement("div");
        brand.className = this.store.config.isSmall ? "font-11 weight-600 margin-right-5" : "font-30 weight-600 margin-right-5";
        brand.textContent = this.formObject.brand || "-";
        left.append(category, brand);
        // ÁTADÁS
        const movebutton = document.createElement("div");
        movebutton.id="movebutton";
        movebutton.className = this.store.config.isSmall ? 'margin-right-10' : 'margin-right-20';
        this.bindLogEvent(movebutton);
        this.moveButton = movebutton;
        this.bindMoveEvent();

        // LOGOK
        this.logbutton.id="logbutton";
        this.bindLogEvent(this.logbutton);
        headerWrapper.append(left, movebutton, this.logbutton);
        this.element = headerWrapper;

        //LOGS
        this.logsContainer.className = this.store.config.isSmall ? "width-60 height-70 position-absolute margin-top-10" : "width-55 height-70 position-absolute margin-top-5";
        this.logsContainer.style.display = "none";
        headerWrapper.append(this.logsContainer);
        
        return headerWrapper;
    }


    bindMoveEvent() {
        this.moveButton.addEventListener("click", async e => {
            e.preventDefault();
            e.stopPropagation();
            this.store.database.deviceToMove = this.formObject;
            if (this.formObject.type === "IT") {
                const activeUsers = await this.store.datas.filter("USERS", "role", "active");
                const user = await this.store.datas.findOne(activeUsers, "id", this.formObject.userid);
                if (user === undefined) {
                    this.store.toast.error("NINCS ILYEN AKTÍV FELHASZNÁLÓ");
                    return;
                }
                this.store.database.moveFrom = user;
            } else if (this.formObject.type === "FURNITURE") {
                const office = await this.store.datas.findOne('CITIES', "officeid", this.formObject.officeid);
                if (office === undefined) {
                    this.store.toast.error("NINCS ILYEN IRODA");
                    return;
                }
                this.store.database.moveFrom = office;
            }

            this.store.levelController.setLevel({name: "MOVE", office: null, position: null});
        });
    }


    bindLogEvent(logbutton) {
        logbutton.addEventListener("click", async e => {
            e.preventDefault();
            e.stopPropagation();
            // Ha már nyitva van a log, zárjuk be
            if (this.logsVisible) {
                this.logsVisible = false;
                this.logsContainer.style.display = "none";
                this.logbutton.id="logbutton";
                this.onHideLogs?.();
                return;
            }
            const logList = await this.store.datas.filter('LOGS', 'itemid', this.formObject.id);
            logList.sort((a, b) => a.timestamp - b.timestamp);
            if (logList.length === 0) {
                logbutton.textContent = "NINCSENEK LOGOK";
                return;
            }
            this.logsContainer.style.display = "block";
            const logsElement = this.logs.render(logList);
            this.logsContainer.innerHTML = "";
            this.logsContainer.appendChild(logsElement);
            this.logsVisible = true;
            this.logbutton.id="formbutton";
            this.logsContainer.style.display = "block";
            this.onShowLogs?.();
        });
    }
}